import React, { useState, useEffect } from 'react';
import { Link, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import styles from './authPage.module.css';
import LoginForm from './login/loginForm';
import RegistroForm from './registro/registroForm';
import ForgotPinForm from './forgot/forgotPinForm';
import { useAuth } from '../../../context/authContext';
import { saveReferralCode } from '../../../services/campaignAttribution';
import bannerWeb from '../../../assets/banners/Banner Registrarse Web-01.png';
import bannerMobile from '../../../assets/banners/Banner Registrarse Movil-02.png';
import useBanners from '../../../hooks/useBanners';

export default function AuthPage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, isLoading } = useAuth();
  // Banner del admin (Marketing → Banners, posición "Registro"); si no hay, el fijo.
  const { banners: registerBanners } = useBanners('REGISTER');
  const adminBanner = registerBanners[0];
  const bannerSrc = adminBanner?.image_url || bannerWeb;
  const bannerSrcMobile = adminBanner ? (adminBanner.image_mobile_url || adminBanner.image_url) : bannerMobile;
  const bannerAlt = adminBanner?.title || 'Recarga $10 mil y te regalamos una fracción de un billete de lotería';
  // Enlace de invitación (/auth?ref=CODIGO desde "Referidos"): abre el registro con el código.
  const refCode = (searchParams.get('ref') || '').trim();
  const [mode, setMode] = useState(() => {
    // Se guarda antes de montar el formulario para que lo lea al iniciar.
    if (refCode) saveReferralCode(refCode.toUpperCase());
    if (location.state?.mode === 'registro' || refCode) return 'registro';
    return location.state?.mode === 'forgot' ? 'forgot' : 'login';
  });

  useEffect(() => {
    if (location.state?.mode === 'registro') setMode('registro');
    if (location.state?.mode === 'login') setMode('login');
    if (location.state?.mode === 'forgot') setMode('forgot');
  }, [location.state?.mode]);

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    const redirectTo =
      location.state?.returnTo || location.state?.from || '/welcome';
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className={styles.layout}>
      <aside className={styles.brandPanel}>
        <picture className={styles.brandPicture}>
          <source
            media="(max-width: 900px)"
            srcSet={bannerSrcMobile}
          />
          <img
            src={bannerSrc}
            alt={bannerAlt}
            className={styles.brandBanner}
          />
        </picture>
        <Link to="/welcome" className={styles.backLink}>
          <span aria-hidden="true">←</span>
          Volver al inicio
        </Link>
      </aside>

      <section className={styles.formPanel}>
        {mode !== 'forgot' && (
          <div className={styles.formHeader}>
            <div className={styles.modeTabs}>
              <button
                type="button"
                className={mode === 'login' ? styles.modeActive : styles.modeBtn}
                onClick={() => setMode('login')}
              >
                Iniciar sesión
              </button>
              <button
                type="button"
                className={mode === 'registro' ? styles.modeActive : styles.modeBtn}
                onClick={() => setMode('registro')}
              >
                Registrarse
              </button>
            </div>
          </div>
        )}

        {mode === 'login' && (
          <LoginForm
            onSwitch={() => setMode('registro')}
            onForgot={() => setMode('forgot')}
            returnTo={location.state?.returnTo}
          />
        )}
        {mode === 'registro' && (
          <RegistroForm
            onSwitch={() => setMode('login')}
            prefilled={location.state?.prefilled}
            returnTo={location.state?.returnTo}
          />
        )}
        {mode === 'forgot' && (
          <ForgotPinForm
            onBack={() => setMode('login')}
            onSuccess={() => setMode('login')}
          />
        )}
      </section>
    </div>
  );
}
